import { z } from "zod";
export const TranscriptWordSchema = z.object({
    text: z.string(),
    start_time: z.number(),
    end_time: z.number(),
});
export const WebhookTranscriptUpdateSchema = z.object({
    original_transcript_id: z.number().optional(),
    speaker: z.string(),
    speaker_id: z.number(),
    words: z
        .array(z.object({
        text: z.string(),
        start_time: z.number(),
        end_time: z.number(),
    }))
        .min(1),
    is_final: z.boolean(),
    language: z.string().nullable().optional(),
    source: z.string().nullable().optional(),
});
// Common schema for both transcript.data and transcript.partial_data
const RecallTranscriptDataSchema = z.object({
    data: z.object({
        words: z.array(z.object({
            text: z.string(),
            start_timestamp: z.object({
                relative: z.number(),
            }),
            end_timestamp: z
                .object({
                relative: z.number(),
            })
                .nullable()
                .optional(),
        })),
        participant: z.object({
            id: z.number(),
            name: z.string().nullable(),
            is_host: z.boolean(),
            platform: z.string().nullable(),
            extra_data: z.record(z.unknown()).nullable().optional(),
        }),
    }),
    realtime_endpoint: z.object({
        id: z.string(),
        metadata: z.record(z.unknown()),
    }),
    transcript: z.object({
        id: z.string(),
        metadata: z.record(z.unknown()),
    }),
    recording: z.object({
        id: z.string(),
        metadata: z.record(z.unknown()),
    }),
    bot: z.object({
        id: z.string(),
        metadata: z.record(z.unknown()),
    }),
});
export const TranscriptEventSchema = z.object({
    event: z.literal("transcript.data"),
    data: RecallTranscriptDataSchema,
});
export const PartialTranscriptEventSchema = z.object({
    event: z.literal("transcript.partial_data"),
    data: RecallTranscriptDataSchema,
});
export const TranscriptProcessingEventSchema = z.object({
    event: z.literal("transcript.processing"),
    data: z.object({
        bot: z.object({
            id: z.string(),
            metadata: z.record(z.unknown()),
        }),
        data: z.object({
            code: z.string(),
            sub_code: z.string().nullable(),
            updated_at: z.string(),
        }),
        recording: z.object({
            id: z.string(),
            metadata: z.record(z.unknown()),
        }),
        transcript: z.object({
            id: z.string(),
            metadata: z.record(z.unknown()),
        }),
    }),
});
export const TranscriptDeletedEventSchema = z.object({
    event: z.literal("transcript.deleted"),
    data: z.object({
        bot: z.object({
            id: z.string(),
            metadata: z.record(z.unknown()),
        }),
        data: z.object({
            code: z.string(),
            sub_code: z.string().nullable(),
            updated_at: z.string(),
        }),
        recording: z.object({
            id: z.string(),
            metadata: z.record(z.unknown()),
        }),
        transcript: z.object({
            id: z.string(),
            metadata: z.record(z.unknown()),
        }),
    }),
});
// Transcript item schema (from packages/shared/src/types/transcript.ts)
export const TranscriptItemSchema = z.object({
    id: z.string(),
    speaker: z.string(),
    text: z.string(),
    startTime: z.number(),
    endTime: z.number(),
});
export const TranscriptSchema = z.array(TranscriptItemSchema);
// Extended transcript update with additional fields (from schemas/TranscriptUpdate.ts)
// TODO: Import TranscriptQuestionClassificationSchema when schemas are migrated
export const TranscriptUpdateSchema = WebhookTranscriptUpdateSchema.extend({
    id: z.string(),
    latency: z.number().optional(),
    end_latency: z.number().optional(),
    // classification: TranscriptQuestionClassificationSchema.optional(), // TODO: Add when migrated
});
